<script lang="ts">
export default { name: 'PinCreateForm' };
</script>

<script setup lang="ts">
// COMPONENTS
import { GInputCode } from '@flash-global66/g-input-code';
import { GButton } from '@flash-global66/g-button';
import { GImage } from '@flash-global66/g-image';

// COMPOSABLES
import { usePinCreateForm } from './usePinCreateForm';

import type { PinEmits } from '../../types/pin.type';

const emits = defineEmits<PinEmits>();

const {
  primaryErrorMessage,
  secondaryErrorMessage,
  isDisableOnContinue,
  onChangeCode,
  onCompletePrimary,
  onCompleteSecondary,
  onKeyPressToValidate,
  onContinue,
  onCloseSession,
} = usePinCreateForm(emits);
</script>

<template>
  <div
    class="flex flex-col bg-gray-10 w-full h-full"
    data-test="pin:create-form"
  >
    <div class="flex flex-col justify-center items-center flex-grow">
      <GImage name="lock" size="xl" class="mb-md" />

      <section class="text-center">
        <h4 class="text-8 text-primary-txt font-semibold">Crear tu nuevo PIN</h4>
        <h5 class="text-secondary-txt mt-xs">
          ¡Recuerda elegir un PIN que sea fácil de recordar!
        </h5>
      </section>
      <section class="mt-9">
        <g-input-code
          password
          :fields="4"
          :text-error="primaryErrorMessage"
          @complete="onCompletePrimary"
          @change="onChangeCode($event, 'PRIMARY')"
          data-test="input:pin-primary"
        />

        <div>
          <h5 class="text-secondary-txt text-5 mt-6 mb-2">Confirma tu PIN</h5>
          <g-input-code
            password
            :fields="4"
            :text-error="secondaryErrorMessage"
            @complete="onCompleteSecondary"
            @change="onChangeCode($event, 'SECONDARY')"
            @validate="onKeyPressToValidate()"
            data-test="input:pin-secondary"
          />
        </div>
      </section>
    </div>
    <section class="flex justify-center mb-8">
      <g-button
        class="mr-3"
        variant="tertiary"
        @click="onCloseSession"
        data-test="button:logout"
      >
        Cerrar sesión
      </g-button>
      <g-button
        class="px-14"
        :disabled="isDisableOnContinue"
        @click="onContinue"
        data-test="button:continue"
        >Continuar
      </g-button>
    </section>
  </div>
</template>
